export const CLASSIFICATIONS_LABELS = {
    UNIFORMATII2015: 'Uniformat II 2015',
    FB5UNIFORMAT: 'FlexBim5 Uniformat',
};
